/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const calendarConnectionResponseProviderSchema = z.enum(['google', 'microsoft_365'])

export type CalendarConnectionResponseProviderSchema = z.infer<typeof calendarConnectionResponseProviderSchema>
